import React from 'react'

import GroupWrapper from '../../components/GroupWrapper'
import Flex from '../../../../../components/layouts/Flex'

import RecruitmentFunnelTrendChart from './RecruitmentFunnelTrendChart'
import RecruitmentChannelsChart from './RecruitmentChannelsChart'

const QuarterlyCharts = () => {
    return (
        <GroupWrapper title="Charts - Quarterly">
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <RecruitmentFunnelTrendChart />
            </Flex>

            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <RecruitmentChannelsChart />
            </Flex>
        </GroupWrapper>
    )
}

export default QuarterlyCharts
